import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslations } from 'next-intl';

import useStyles from './styles';

const Points = ({ data, setScrollTarget }) => {
  const t = useTranslations();
  const styles = useStyles();

  return (
    <div className={styles['points-container']}>
      <h3 className="title-content">{t('contents_title')}</h3>
      {data.map((title, index) => (
        <p
          className="sub-title-content"
          key={title + index}
          onClick={() => setScrollTarget(title)}
        >
          {' '}
          {index + 1}. {t(title)}
        </p>
      ))}
    </div>
  );
};
Points.propTypes = {
  data: PropTypes.array.isRequired,
  setScrollTarget: PropTypes.func,
};
export default memo(Points);
